import axios from '../utils/axios';

export default function getVerifiedCompanyRecruiters (adminId, params) {
    return axios.get(`/admin/${adminId}/get-verified-company-recruiters`, { params });
}